var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"banner-status-badge",style:({ backgroundColor: _vm.config.badgeColor })},[_vm._v(" "+_vm._s(_vm.config.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }